<template>
  <div>
    <CRow>
      <CCol lg="12">
        <h1 class="main-header" v-translate translate-context="region">
          Region List
        </h1>
        <CCard class="">
          <CCardHeader>
            <div class="card-header-actions">
              <router-link :to="{name: 'region.new'}" v-if="hasPerm('admin.region.create')">
                <CButton block color="primary" v-translate translate-context="list.actions">Create</CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody class="px-0">
            <AjaxTable
                :fields="fields"
                :data="regions"
                :fetch="fetchRegionList"
            >
              <template #actions="{item}">
                <td class="text-right">
                  <CButton size="sm" variant="outline" color="primary" class="mr-2"
                           v-if="hasPerm('admin.plan_category.list')"
                           @click="$router.push({name: 'plan_category.list', params: {region: item.id}})"
                           v-translate translate-context="list.actions"
                  >
                    Categories
                  </CButton>
                  <CButton size="sm" variant="outline" color="primary" class="mr-2"
                           v-if="hasPerm('admin.region.update')"
                           @click="$router.push({name: 'region.edit', params: {id: item.id}})"
                           v-translate translate-context="list.actions"
                  >
                    Edit
                  </CButton>
                  <CButton @click="onDelete(item.id)" size="sm" variant="outline" color="danger"
                           v-if="hasPerm('admin.region.delete')"
                           v-translate translate-context="list.actions"
                  >
                    Delete
                  </CButton>
                </td>
              </template>
            </AjaxTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AjaxTable from "@/domain/core/components/AjaxTable.vue";

export default {
  name: 'ListRegion',
  components: {AjaxTable},
  data() {
    return {
      fields: [
        {key: 'id', label: this.$pgettext('region.list','ID'), _style: 'width:100px;'},
        {key: 'name', label: this.$pgettext('region.list','Name')},
        {key: 'is_public', label: this.$pgettext('region.list','Public')},
        {key: 'actions', label: this.$pgettext('region.list','Actions'), sorter: false, filter: false}
      ],
    }
  },
  async mounted() {
    await this.fetchConfig({type:'admin'})
  },
  computed: {
    ...mapGetters('region', [
      'regions',
    ]),
  },
  methods: {
    ...mapActions('region', [
      'fetchRegionList',
      'deleteRegion'
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    onDelete(id) {
      this.confirm({
          title: 'Are your sure?',
          message: 'This action is irreversible',
          cb_confirm: async () => {
            await this.deleteRegion(id)
          }
      })
    }
  }
}
</script>